import { Injectable } from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class StorageService {
    private storageSub = new Subject<boolean>();
    private patientCurrentSub = new Subject<any>();
    private patientIdSub = new Subject<any>();

    watchStorage(): Observable<any> {
        return this.storageSub.asObservable();
    }
    setItem(key: string, data: any) {
        localStorage.setItem(key, data);
        this.storageSub.next(true);
        if (key === 'patientCurrent') {
            this.patientCurrentSub.next(data);
        } else if (key === 'patientId') {
            this.patientIdSub.next(data);
        }
    }

    removeItem(key) {
        localStorage.removeItem(key);
        this.storageSub.next(true);
    }

    watchPatientCurrent(): Observable<any> {
        return this.patientCurrentSub.asObservable();
    }

    watchPatientId(): Observable<any> {
        return this.patientIdSub.asObservable();
    }
}
